import React, { createContext, useContext, useMemo, useState } from "react";
import { cognitoLogin } from "../helpers/cognitoLogin";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [accessToken, setAccessToken] = useState(() => localStorage.getItem("accessToken") || "");
  const [idToken, setIdToken] = useState(() => localStorage.getItem("idToken") || "");

  // ✅ Preferimos accessToken
  const isAuthed = !!accessToken || !!idToken;

  async function login(username, password) {
    const r = await cognitoLogin(String(username || "").trim(), String(password || ""));
    const at = r?.accessToken || "";
    const it = r?.idToken || "";

    // Si tu cognitoLogin hoy solo regresa idToken, esto te lo va a evidenciar
    if (!at && !it) throw new Error("No se recibió token de Cognito");

    setAccessToken(at);
    setIdToken(it);

    if (at) localStorage.setItem("accessToken", at);
    else localStorage.removeItem("accessToken");

    if (it) localStorage.setItem("idToken", it);
    else localStorage.removeItem("idToken");

    return { accessToken: at, idToken: it };
  }

  function setTokens({ accessToken: at, idToken: it } = {}) {
    const _at = at || "";
    const _it = it || "";

    setAccessToken(_at);
    setIdToken(_it);

    if (_at) localStorage.setItem("accessToken", _at);
    else localStorage.removeItem("accessToken");

    if (_it) localStorage.setItem("idToken", _it);
    else localStorage.removeItem("idToken");
  }

  function logout() {
    setAccessToken("");
    setIdToken("");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("idToken");
  }

  const value = useMemo(
    () => ({
      accessToken,
      idToken,
      isAuthed,
      login,
      logout,
      setTokens,
    }),
    [accessToken, idToken, isAuthed]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth debe usarse dentro de <AuthProvider>");
  return ctx;
}
